export function FlagVideoBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <img
        src="https://images.unsplash.com/photo-1628598996952-3431530d7dae?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=60&w=800"
        alt=""
        className="absolute inset-0 w-full h-full object-cover scale-110"
        loading="eager"
        fetchpriority="high"
        decoding="async"
        draggable={false}
      />
      <div className="absolute inset-0 bg-white/70 sm:bg-white/65" />
      <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-transparent to-white/90" />
    </div>
  );
}
